export type EducationResource = {
    id: string;
    title: string;
    type: 'video' | 'news';
    image?: string;  // Imagen para noticias
    shortDescription?: string;  // Descripción corta para noticias
    videoUrl?: string;  // URL para el video
    category: string;  // Categoría del recurso
    newsUrl?: string;  // URL para la noticia
};

function getYouTubeThumbnail(videoUrl: string): string {
    let videoId = '';
    if (videoUrl.includes('youtu.be')) {
        videoId = videoUrl.split('youtu.be/')[1];
    } else if (videoUrl.includes('v=')) {
        videoId = videoUrl.split('v=')[1];
    }

    if (videoId.includes('&')) {
        videoId = videoId.split('&')[0];
    }

    return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
}

export const educationResourcesConfig: EducationResource[] = [
    {
        id: '14',
        title: ' Frederick Castillo #6 | Proyectos de BGA en México: Piamont y Zentral Residencial',
        type: 'video',
        videoUrl: 'https://youtu.be/EcXzkPx6VkY?si=qeYqko-QH8HJZ4Nv',
        category: 'Educativo',
        image: getYouTubeThumbnail('https://youtu.be/EcXzkPx6VkY?si=qeYqko-QH8HJZ4Nv') 
    },
    {
        id: '13',
        title: 'Víctor García de Paredes #5 | Emprendedor y Creador de Contenido sobre Software e IA a medida',
        type: 'video',
        videoUrl: 'https://youtu.be/-swWQ6KwPhU?si=RRHL_qAAYrbdC508',
        category: 'Educativo',
        image: getYouTubeThumbnail('https://youtu.be/-swWQ6KwPhU?si=RRHL_qAAYrbdC508') 
    },
    {
        id: '12',
        title: 'TokenMeet en #SURWinesGourmet Parte 2 | Con Lorena y Rocío Morales',
        type: 'video',
        videoUrl: 'https://youtu.be/L7ai63jl7oo',
        category: 'Informativa',
        image: getYouTubeThumbnail('https://youtu.be/L7ai63jl7oo') 
    },
    {
        id: '11',
        title: 'TokenMeet en #SURWinesGourmet Parte 2 | Con Lorena y Rocío Morales',
        type: 'video',
        videoUrl: 'https://youtu.be/xKzQOjCLdjc?si=kT0xMbjoBFr9tEm_',
        category: 'Informativo',
        image: getYouTubeThumbnail('https://youtu.be/xKzQOjCLdjc?si=kT0xMbjoBFr9tEm_') 
    },
    
    {
        id: '10',
        title: 'Javier López #4 | Asesor Web 3 de FNDB (Federación Nacional de Digitalización y Blockchain)',
        type: 'video',
        videoUrl: 'https://youtu.be/GCMhtbI6fVk',
        category: 'Informativa',
        image: getYouTubeThumbnail('https://youtu.be/GCMhtbI6fVk') 
    },
    {
        id: '9',
        title: 'TokenMeet en #SURWinesGourmet | Con Juanjo Escudero Marcos',
        type: 'video',
        videoUrl: 'https://youtu.be/G-fHb0tbeZU',
        category: 'Informativa',
        image: getYouTubeThumbnail('https://youtu.be/G-fHb0tbeZU') 
    },

    {
        id: '7',
        title: 'Cómo Abrir Tu Primera Wallet Digital para la Tokenización de Activos',
        type: 'video',
        videoUrl: 'https://youtu.be/TFt1fRT44MA',
        category: 'Educativo',
        image: getYouTubeThumbnail('https://youtu.be/TFt1fRT44MA') 
    },
    
   
    
    {
        id: '6',
        title: 'Entrevista a Alberto Valdés (CEO de Arkand-Arkibit)',
        type: 'video',
        videoUrl: 'https://youtu.be/lASybBAeK3Q',
        category: 'Informativa',
        image: getYouTubeThumbnail('https://youtu.be/lASybBAeK3Q') 
    },
    {
        id: '5',
        title: 'Entrevista a Nani Boronat',
        type: 'video',
        videoUrl: 'https://youtu.be/8hg_baW6tlw?si=cDlO0wtKL3ID20uh',
        category: 'Informativa',
        image: getYouTubeThumbnail('https://youtu.be/8hg_baW6tlw?si=cDlO0wtKL3ID20uh') 
    },
    
    {
        id: '3',
        title: 'Como participar en los proyectos de los miembros de la comunidad',
        type: 'video',
        videoUrl: 'https://youtu.be/fosp_8-Kfyc?si=GciRunwTsM5eVQf0',
        category: 'Blockchain',
        image: getYouTubeThumbnail('https://youtu.be/fosp_8-Kfyc?si=GciRunwTsM5eVQf0') 
    },
    
    {
        id: '1',
        title: 'Presentación de TokenMeet por Manuel Escudero',
        type: 'video',
        videoUrl: 'https://youtu.be/zFZ5uRuf1lQ?si=yTTtyNTxaCoSJnLk',
        category: 'Informativo',
        image: getYouTubeThumbnail('https://youtu.be/zFZ5uRuf1lQ?si=yTTtyNTxaCoSJnLk') 
    },
];
